import { render, staticRenderFns } from "./ShopBundleAgreementRecord.vue?vue&type=template&id=68e1f987&"
import script from "./ShopBundleAgreementRecord.vue?vue&type=script&lang=js&"
export * from "./ShopBundleAgreementRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports